import analyticsApiClient from './utils/analyticsApiClient';

const analytics = analyticsApiClient('spare-parts');

export default analytics;
